import React, { useState } from "react";
import authStore from "@/stores/authStore";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { Box } from "@mui/material";
import Sidebar from "@/components/sidebar";
import Header from "@/components/header/header";
import { useTranslation } from "react-i18next";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

const cacheLtr = createCache({
    key: "muiltr",
});

const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
});

const Layout = () => {
    const location = useLocation();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [settingsSideMenu, setSettingsSideMenu] = useState(pathname.includes("/settings"));
    function toggleAdditionalMenu(e: boolean) {
        if (settingsSideMenu !== e) {
            setSettingsSideMenu(e);
        }
    }
    function* renderer() {
        yield (
            <div key="main-content" className={`main-content ${settingsSideMenu ? "menu-expanded" : "menu-hidden"}`}>
                <div key="sidebar">
                    <Box>
                        <Sidebar toggleSideBar={toggleAdditionalMenu} />
                    </Box>
                </div>
                {settingsSideMenu ? (
                    <div
                        key="additional_settings_sidebar"
                        onMouseEnter={() => setSettingsSideMenu(true)}
                        className="additional_settings_sidebar"
                    >
                        <p className="settings_menu_header">
                            <i className="icon-f icon-settings-icon2 fs-24"></i>
                            <span>{t("sidebar.Settings")}</span>
                        </p>
                        <button
                            className={`settings_menu_btn ${
                                pathname.includes("/settings/manage-users") ? "active" : ""
                            }`}
                            onClick={() => navigate("/settings/manage-users")}
                        >
                            {t("settings.menu.manageUsers")}
                        </button>
                        <button
                            className={`settings_menu_btn ${
                                pathname.includes("/settings/manage-profiles") ? "active" : ""
                            }`}
                            onClick={() => navigate("/settings/manage-profiles")}
                        >
                            {t("settings.menu.manageProfiles")}
                        </button>
                        <button
                            className={`settings_menu_btn ${
                                pathname.includes("/settings/manage-interface") ? "active" : ""
                            }`}
                            onClick={() => navigate("/settings/manage-interface")}
                        >
                            {t("settings.menu.importHistory")}
                        </button>
                        <button
                            className={`settings_menu_btn ${
                                pathname.includes("/settings/manage-organization-units") ? "active" : ""
                            }`}
                            onClick={() => navigate("/settings/manage-organization-units")}
                        >
                            {t("settings.menu.manageOrganization")}
                        </button>
                        <button
                            className={`settings_menu_btn ${
                                pathname.includes("/settings/manage-employee-groups") ? "active" : ""
                            }`}
                            onClick={() => navigate("/settings/manage-employee-groups")}
                        >
                            {t("settings.menu.manageEmployeeGroups")}
                        </button>
                    </div>
                ) : (
                    ""
                )}
                <div key="header">
                    <Header />
                </div>
                <CacheProvider value={authStore.isRtl ? cacheRtl : cacheLtr}>
                    <div key="page-content" className="page-content">
                        <Outlet />
                    </div>
                </CacheProvider>
            </div>
        );
    }

    const render = () => {
        if (!authStore.isAuthenticated) {
            const returnUrl = encodeURIComponent(location.pathname);
            const to = `/login?return=${returnUrl}`;
            return <Navigate to={to} replace />;
        }
        return <div>{Array.from(renderer())}</div>;
    };

    return render();
};

export default observer(Layout);
